import { Menu, Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useNavigation } from "../../hooks/useNavigation";
import { useState, useContext } from "react";
import { AuthContext } from "../../useAuth";
import LoginForm from "../LoginForm";
import { useNavigate } from "react-router-dom";
import { useFeatureFlag } from "../../api/FeatureFlags";

const Navigation = ({ withBrand }) => {
  const [showlogin, setShowLogin] = useState(false);

  const loginAction = () => {
    setShowLogin(true);
  };

  const items = useNavigation(loginAction, withBrand);

  const navigate = useNavigate();

  return (
    <>
      <Menu
        onClick={(e) => {
          if (e.key && e.key.startsWith("/")) navigate(e.key);
        }}
        style={{}}
        mode="horizontal"
        // style={{ display: "block" }}
        items={items}
        overflowedIndicator={<FontAwesomeIcon icon={faBars} />}
      />
      <Modal
        open={showlogin}
        title={"Login"}
        onCancel={() => setShowLogin(false)}
        footer={[]}
      >
        <LoginForm onSuccess={() => setShowLogin(false)} />
      </Modal>
    </>
  );
};

export default Navigation;
